export default __webpack_public_path__ + "static/media/canceled.1c2963ee.png";